import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=565f9cf3&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=ts&"
export * from "./Loader.vue?vue&type=script&lang=ts&"
import style0 from "@/scss/components/loader/_loader.scss?vue&type=style&index=0&id=565f9cf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f9cf3",
  null
  
)

export default component.exports